import React from 'react';
import { useParams } from 'react-router-dom';
import InvitationView from '../components/InvitationView';

/** `/invite/:token` — the invitation a link I opened offers, signed in or out. */
export default function ShareInvitationPage() {
  const { token = '' } = useParams<{ token: string }>();
  return <InvitationView source={{ kind: 'link', token }} />;
}
